import { IInitAction } from './init'
import { UserDateType } from './date'

// Action types
export enum types {
  CREATE_MEDIA_TYPE__STARTED = 'CREATE_MEDIA_TYPE__STARTED',
  CREATE_MEDIA_TYPE__SUCCESS = 'CREATE_MEDIA_TYPE__SUCCESS',
  CREATE_MEDIA_TYPE__FAILURE = 'CREATE_MEDIA_TYPE__FAILURE',
  UPDATE_MEDIA_TYPE__STARTED = 'UPDATE_MEDIA_TYPE__STARTED',
  UPDATE_MEDIA_TYPE__SUCCESS = 'UPDATE_MEDIA_TYPE__SUCCESS',
  UPDATE_MEDIA_TYPE__FAILURE = 'UPDATE_MEDIA_TYPE__FAILURE',
  DELETE_MEDIA_TYPE__STARTED = 'DELETE_MEDIA_TYPE__STARTED',
  DELETE_MEDIA_TYPE__SUCCESS = 'DELETE_MEDIA_TYPE__SUCCESS',
  DELETE_MEDIA_TYPE__FAILURE = 'DELETE_MEDIA_TYPE__FAILURE',
  GET_MEDIA_TYPE_BY_ID__STARTED = 'GET_MEDIA_TYPE_BY_ID__STARTED',
  GET_MEDIA_TYPE_BY_ID__SUCCESS = 'GET_MEDIA_TYPE_BY_ID__SUCCESS',
  GET_MEDIA_TYPE_BY_ID__FAILURE = 'GET_MEDIA_TYPE_BY_ID__FAILURE',
}

export interface ICreateMediaTypeAction {
  type: types.CREATE_MEDIA_TYPE__STARTED
  mediaTypeData: IMediaType
}

export interface ICreateMediaTypeSuccessAction {
  type: types.CREATE_MEDIA_TYPE__SUCCESS
  mediaTypeData: IMediaType
  message: string
}

export interface IGetMediaTypeByIdAction {
  type: types.GET_MEDIA_TYPE_BY_ID__STARTED
  extension: string
}

export interface IGetMediaTypeByIdSuccessAction {
  type: types.GET_MEDIA_TYPE_BY_ID__SUCCESS
  mediaTypeData: IMediaType
}

export interface IUpdateMediaTypeAction {
  type: types.UPDATE_MEDIA_TYPE__STARTED
  mediaTypeData: IMediaType
}

export interface IUpdateMediaTypeSuccessAction {
  type: types.UPDATE_MEDIA_TYPE__SUCCESS
  mediaTypeData: IMediaType
  message: string
}

export interface IDeleteMediaTypeAction {
  type: types.DELETE_MEDIA_TYPE__STARTED
  extension: string
}

export interface IDeleteMediaTypeSuccessAction {
  type: types.DELETE_MEDIA_TYPE__SUCCESS
  message: string
}

export interface IFailureAction {
  type:
    | types.CREATE_MEDIA_TYPE__FAILURE
    | types.GET_MEDIA_TYPE_BY_ID__FAILURE
    | types.UPDATE_MEDIA_TYPE__FAILURE
    | types.DELETE_MEDIA_TYPE__FAILURE
  message: string
}

export type MediaTypeActionsType =
  | ICreateMediaTypeAction
  | ICreateMediaTypeSuccessAction
  | IGetMediaTypeByIdAction
  | IGetMediaTypeByIdSuccessAction
  | IUpdateMediaTypeAction
  | IUpdateMediaTypeSuccessAction
  | IDeleteMediaTypeAction
  | IDeleteMediaTypeSuccessAction
  | IFailureAction
  | IInitAction

export interface IMediaType extends UserDateType {
  isLoading?: boolean
  message?: string
  extension: string
  title: string
  mimeType: string
  mediaContentType: string
  priority?: number
}
